import { memo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Dropdown, DropdownDivider } from 'foundations-components/transitional/components/Dropdown';
import { List } from 'foundations-components/transitional/components/List';
import { Flex } from 'foundations-components/components/Flex';
import { CPQ_BETA_GATE, PRODUCT_BUILDER_GATE } from 'products-ui-components/constants/permissions';
import { usePermissionsContext } from '../contexts/PermissionsContext';
import { ProductHighlightCloneButton } from './actions/ProductHighlightCloneButton';
import { ProductHighlightCustomizePreview } from './actions/ProductHighlightCustomizePreview';
import { ProductHighlightDeleteButton } from './actions/ProductHighlightDeleteButton';
import { ProductHighlightEditButton } from './actions/ProductHighlightEditButton';
import { ProductHighlightStatusToggleButton } from './actions/ProductHighlightStatusToggleButton';
import { ProductHighlightViewPropertiesButton } from './actions/ProductHighlightViewPropertiesButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ProductHighlightActionsComponent = () => {
  const {
    hasGate,
    hasScope
  } = usePermissionsContext();
  const isUserUngatedForProductEditor = hasGate(PRODUCT_BUILDER_GATE);
  const isUserUngatedForCPQBeta = hasGate(CPQ_BETA_GATE);
  const hasPermissionToDeleteProducts = hasScope('product-library-all-delete');
  const canUserAccessProductEditor = isUserUngatedForProductEditor || isUserUngatedForCPQBeta;
  return /*#__PURE__*/_jsx(Flex, {
    paddingBlock: "600",
    paddingInlineEnd: "600",
    justifyContent: "end",
    children: /*#__PURE__*/_jsx(Dropdown, {
      buttonUse: "link",
      buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "actions.title"
      }),
      "data-test-id": "product-highlight-actions",
      children: /*#__PURE__*/_jsxs(List, {
        wrapChildren: true,
        children: [canUserAccessProductEditor && /*#__PURE__*/_jsx(ProductHighlightEditButton, {}), /*#__PURE__*/_jsx(ProductHighlightCloneButton, {}), canUserAccessProductEditor && /*#__PURE__*/_jsx(ProductHighlightStatusToggleButton, {}), /*#__PURE__*/_jsx(ProductHighlightViewPropertiesButton, {}), /*#__PURE__*/_jsx(ProductHighlightCustomizePreview, {}), canUserAccessProductEditor && hasPermissionToDeleteProducts && /*#__PURE__*/_jsx(DropdownDivider, {}), canUserAccessProductEditor && /*#__PURE__*/_jsx(ProductHighlightDeleteButton, {})]
      })
    })
  });
};
export const ProductHighlightActions = /*#__PURE__*/memo(ProductHighlightActionsComponent);